export default __webpack_public_path__ + "static/media/model_compare_thumbnail.3c909dd2.png";